module.exports = __webpack_public_path__ + "static/apple-icon-144x144-d4aeed5a483aa34310a5cd940c970e6b.png";